import React, { FC, useEffect } from 'react'
import { useParams, Redirect } from 'react-router-dom'
import { useDriverViewApi } from 'apps/fleet-planner/hooks'
import {
  IShipmentInOutUpdate,
  IShipmentStatusUpdate,
  IShipmentPodUpdate,
} from 'apps/fleet-planner/types'
import { submitLocation } from 'apps/fleet-planner/utils/api'
import { ShareLoadDetailsDisplay, ISubmitOneTimeLocation } from './ShareLoadDetailsDisplay'

export const ShareLoadDetails: FC = () => {
  const {
    getShipment,
    isShipmentDetailsLoading,
    isShipmentUpdating,
    isTimeZoneError,
    load,
    shipmentDetailsErrors,
    shipmentUpdateErrors,
    updateCheckInOutTimes,
    updateShipmentStatus,
    uploadPodAttachment,
  } = useDriverViewApi()
  const { id: loadId = '', token: authToken = '' } = useParams<{ id: string; token: string }>()

  const submitHandler = (shipmentId: string, shipment: IShipmentStatusUpdate) => {
    return updateShipmentStatus(shipmentId, shipment, authToken)
  }

  const editHandler = (shipmentId: string, stopId: string, stop: IShipmentInOutUpdate) => {
    return updateCheckInOutTimes(shipmentId, stopId, stop, authToken)
  }

  const uploadPodHandler = (shipment: IShipmentPodUpdate) => {
    return uploadPodAttachment(loadId, shipment, authToken)
  }

  const submitOneTimeLocationHandler = async ({
    externalStopId,
    isManual,
    latitude,
    longitude,
  }: ISubmitOneTimeLocation) => {
    return submitLocation(loadId, latitude, longitude, isManual, authToken, externalStopId)
  }

  // Fetch load details when token is present
  useEffect(() => {
    if (authToken) {
      getShipment(loadId, authToken)
    }
  }, [authToken, loadId])

  return (
    <>
      <ShareLoadDetailsDisplay
        onPodUpload={uploadPodHandler}
        onSubmitLocation={submitOneTimeLocationHandler}
        isShipmentUpdating={isShipmentUpdating}
        isLoading={isShipmentDetailsLoading}
        onEdit={editHandler}
        onSubmit={submitHandler}
        shipmentUpdateErrors={shipmentUpdateErrors}
        load={load}
        hasToken={!!authToken}
        shareToken={authToken}
        isTimeZoneError={isTimeZoneError}
      />
      {!isShipmentDetailsLoading && shipmentDetailsErrors && <Redirect to='/share-load/expired' />}
    </>
  )
}

export default ShareLoadDetails
